const MOBILE_MAX_WIDTH = 1133;

function isMobileDevice() {
    if (typeof window === "undefined") return true;

    const userAgent = String(window.navigator?.userAgent || "");
    const isMobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent);
    const isCoarsePointer =
        typeof window.matchMedia === "function" && window.matchMedia("(hover: none) and (pointer: coarse)").matches;

    return window.innerWidth <= MOBILE_MAX_WIDTH || isMobileUa || isCoarsePointer;
}

function buildChatRoute(name, to = {}) {
    return {
        name,
        params: to.params,
        query: to.query,
        hash: to.hash,
        replace: true,
    };
}

function resolveChatRoute(to) {
    return buildChatRoute(isMobileDevice() ? "chat" : "chatbox", to);
}

function ensureChatDeviceRoute(targetName) {
    return (to) => {
        const nextRoute = resolveChatRoute(to);

        if (nextRoute.name === targetName) {
            return true;
        }

        return nextRoute;
    };
}

const routes = [
    {
        path: "/chatbot",
        name: "chatbot",
        beforeEnter: resolveChatRoute,
        component: () => import("@/views/chat/Index.vue"),
    },
    {
        path: "/chat/:id?",
        name: "chat",
        beforeEnter: ensureChatDeviceRoute("chat"),
        component: () => import("@/views/chat/Chat.vue"),
    },
    {
        path: "/chatbox/:id?",
        name: "chatbox",
        beforeEnter: ensureChatDeviceRoute("chatbox"),
        component: () => import("@/views/chat/ChatPc.vue"),
    },
];

export default routes;
